import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpContextToken } from '@angular/common/http';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { EMPTY, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectDelegatedAccessToken } from 'src/app/features/member/member-details/state/member-details.selectors';
import { actionRefreshToken } from '../state/core.actions';
import { POLAuthService } from '../services/auth.service';
import { getRefreshTokenUrl } from '../state/core.selectors';

export const REQUIRES_DELEGATED_ACCESS_TOKEN = new HttpContextToken<boolean>(() => false);
export const ASSOCIATED_DELEGATED_ACCESS_TOKEN = new HttpContextToken<string>(() => null);

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  isUpdating = false; // prevents simultaneous token update requests
  isRefreshInProgress = false;
  delegatedAccessToken: string;
  window = window as any;

  constructor(
    private auth: OidcClientService,
    private router: Router,
    private store: Store,
    private loginService: POLAuthService
  ) {
    this.store.select(selectDelegatedAccessToken).subscribe((delegatedAccessToken: string) => {
      this.delegatedAccessToken = delegatedAccessToken;
    });
    this.store.select(getRefreshTokenUrl).subscribe((refreshToken: { isRefreshInProgress: boolean; url: string }) => {
      this.isRefreshInProgress = refreshToken.isRefreshInProgress;
    });
  }

  isIFrame() {
    return this.window.self !== this.window.top;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requiresDelegatedAccessToken = req.context.get(REQUIRES_DELEGATED_ACCESS_TOKEN);
    const associatedDelegatedAccessToken = req.context.get(ASSOCIATED_DELEGATED_ACCESS_TOKEN);
    const user = this.auth.getUser();
    if (!user || this.auth.isExpired() || this.isIFrame()) {
      this.router.navigate(['unauthorized']);
      return EMPTY;
    }
    if (this.auth.isExpiring() && !this.isRefreshInProgress) {
      this.store.dispatch(
        actionRefreshToken({ refreshToken: { isRefreshInProgress: true, url: this.loginService.refreshTokenUrl(), resetInactivityTime:true } })
      );
    }
    const token = user.id_token;
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
    if (requiresDelegatedAccessToken) {
      req = req.clone({ setHeaders: { Authorization2: `${this.delegatedAccessToken}` } });
    } else {
      if (associatedDelegatedAccessToken) {
        req = req.clone({ setHeaders: { Authorization2: `${associatedDelegatedAccessToken}` } });
      }
    }
    return next.handle(req);
  }
}
